/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 18:00:16
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/Attribute/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
//import css from './css.module.less';

import { Form } from 'src/components/Antd';
import AttributesTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/Attributes';
//import Customer from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerTable';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
// import { useStoreCountries } from '@/src/pages/Settings/Components/SelectCountryArea';

const Attributes = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { disableEdit } = props;
  // const { attributeName } = props;
  // const { list: storeCountries } = useStoreCountries();
  return (
    <SectionWrapper
      style={{ paddingBottom: 32 }}
      title={getI18n('salesChannelSubscriptionBuy.attributes.attributes')}
      subtitle={getI18n('salesChannelSubscriptionBuy.attributes.subtitle')}>
      <Item name={'attributes'}>
        <AttributesTable disableEdit={disableEdit} />
      </Item>

      {/* <RegionTable /> */}
      {/* <Form.Item name={'countryAreas'} initialValue={[]}>
        <CheckCountry list={storeCountries} />
      </Form.Item> */}
    </SectionWrapper>
  );
};

export default Attributes;
